var DurationRecordSign = {};
export {
  DurationRecordSign as __exports
};
